<script lang="ts">
    import Fa from 'svelte-fa'
    import { faEdit, faPlusCircle, faUser } from '@fortawesome/free-solid-svg-icons'
    import { onMount } from 'svelte/internal'
    import Content from '../_common/content.svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import DateSelect from '../_common/date-select.svelte'
    import { GridBadge, GridButton, GridClass, GridCol, GridColTypeEnum, GridLine } from '../_common/z/zgrid'
    import Zgrid from '../_common/z/zgrid.svelte'
    import type { FormData } from '../../modules/toolsApi/forms/form-datas/form-data'
    import Popover from '../_common/popover.svelte'
    import CustomerServiceForm from './customer-service-form.svelte'
    import Zact from '../_common/z/zact.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'

    let step = 1

    let show = false
    let entities: FormData[] = []
    let total = 0

    let dates: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(async () => {
        await loadEntities()
    })

    function dateChanged(event) {
        dates = event.detail
        loadEntities()
    }

    async function loadEntities() {
        try {
            show = true
            total = 0
            const dt = {
                from: dates?.from || undefined,
                to: dates?.to || undefined,
            }
            entities = await window.api.tools.forms.formDatas.getAll(dt)
            entities = await window.api.utils.utils.assignPersonsFromObject(entities)
            loadGrid()
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function getBadgeColor(status: number) {
        if (status === 60) return '#e9a816'
        if (status === 100) return '#328866'
        if (status === 110) return '#645EC9'
        return '#99999930'
    }

    function getStatusLabel(status: number) {
        if (status === 60) return 'Rascunho'
        if (status === 110) return 'Assinado'
        return 'Completo'
    }

    let grid: GridClass = new GridClass()
    function loadGrid() {
        // grid
        grid = new GridClass()
        // grid head
        grid.title = 'Atendimentos Realizados'
        grid.subtitle = ''
        grid.fontSize = '15px'
        grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.badge }))
        grid.cols.push(new GridCol({ content: 'Data', type: GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Pessoa', type: GridColTypeEnum.string, maxLength: 33 }))
        grid.cols.push(new GridCol({ content: 'Modelo', type: GridColTypeEnum.string, maxLength: 45 }))
        const showScore = entities.some((el) => el.scoreMax > 0)
        if (showScore) {
            grid.cols.push(new GridCol({ content: 'Pontuação', type: GridColTypeEnum.string }))
        }
        grid.cols.push(new GridCol({ content: '', type: GridColTypeEnum.button }))
        // grid lines
        for (const item of entities) {
            const btnPerson = new GridButton({
                callback: () => window.person('show', item.personId),
                icon: faUser,
                label: 'Pessoa',
            })
            const btnShow = new GridButton({
                callback: () => showCustomerService(item.formDataId),
                icon: faEdit,
                label: 'Ver',
            })
            const btnEdit = new GridButton({
                callback: () => editCustomerService(item.formDataId),
                icon: faEdit,
                label: 'Editar',
            })
            let line: GridLine = new GridLine()
            line.slots.push({
                content: new GridBadge({
                    label: getStatusLabel(item.status),
                    class: 'status_' + item.status,
                }),
            })
            line.slots.push({ content: item.createdAt })
            line.slots.push({ content: item.person?.name || '[cliente não informado]' })
            line.slots.push({ content: item.template.title })
            if (showScore) {
                line.slots.push({ content: item.scoreMax ? item.score.toString() + '/' + item.scoreMax.toString() : '' })
            }

            let buttons = [btnPerson]
            if (window.store.token.permissions.customerService.entries.read) {
                buttons.push(btnShow)
            }
            if (window.store.token.permissions.customerService.entries.write) {
                buttons.push(btnEdit)
            }
            line.slots.push({ content: buttons })
            grid.lines.push(line)
        }
    }

    let formDataId = ''
    let view = false
    async function newCustomerService() {
        formDataId = ''
        step = 2
        view = false
    }

    async function editCustomerService(id: string) {
        formDataId = id
        step = 2
        view = false
    }

    async function showCustomerService(id: string) {
        formDataId = id
        step = 2
        view = true
    }

    async function customerServiceFormOnChanged() {
        await loadEntities()
        step = 1
        formDataId = ''
        view = false
    }

    async function customerServiceFormOnCancel() {
        await loadEntities()
        step = 1
        formDataId = ''
        view = false
    }
</script>

{#if step === 1}
    <Content footer={true}>
        <Zact>
            <DateSelect shortcuts={true} startFrom={dates.from} startTo={dates.to} on:change={dateChanged} />
            <div class="spacer" />
            {#if window.store.token.permissions.customerService.entries.write}
                <Zbutton color="primary" icon={faPlusCircle} label="Novo atendimento" mobileHideLabel={true} on:click={newCustomerService}></Zbutton>
            {/if}
        </Zact>
        <Zgrid {grid} class="h-space" />
        <LoadSpinner {show} />
    </Content>
{:else}
    <CustomerServiceForm {view} {formDataId} on:change={customerServiceFormOnChanged} on:cancel={customerServiceFormOnCancel}></CustomerServiceForm>
{/if}
